import { createFileRoute } from '@tanstack/react-router';
import { ImportsPage } from '@web/modules/imports/history/imports-page';

export const Route = createFileRoute('/_app/imports/')({ component: ImportsPage });
